const PROJECT_ASSET_TYPES = {
  gif: { name: "gif", id: 20 },
  jpeg: { name: "jpeg", id: 22 },
  jpg: { name: "jpg", id: 23 },
  png: { name: "png", id: 28 },
  pdf: { name: "pdf", id: 127 },
}

export const getProjectAssetType = fileName => {
  const extension = fileName?.split(".")?.pop()?.toLowerCase()
  return PROJECT_ASSET_TYPES[extension]
}

const padDatePart = value => String(value).padStart(2, "0")

export const createUniqueProjectFileName = (fileName, date = new Date()) => {
  const normalizedFileName = fileName?.trim()?.replace(/\s+/g, "-")
  const extensionIndex = normalizedFileName?.lastIndexOf(".") ?? -1

  if (!normalizedFileName || extensionIndex <= 0) return normalizedFileName

  const baseName = normalizedFileName.slice(0, extensionIndex)
  const extension = normalizedFileName.slice(extensionIndex)
  const timestamp = [
    date.getFullYear(),
    padDatePart(date.getMonth() + 1),
    padDatePart(date.getDate()),
    "_",
    padDatePart(date.getHours()),
    padDatePart(date.getMinutes()),
    padDatePart(date.getSeconds()),
  ].join("")

  return `${baseName}_${timestamp}${extension}`
}

export const readFileAsBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result).split(",")[1] ?? "")
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })

export const getProjectUploadResult = (response, fallbackFileName) => {
  const candidates = [
    response,
    response?.data,
    response?.result,
    response?.response,
    response?.body,
    response?.data?.data,
    response?.data?.result,
  ].filter(Boolean)

  for (const candidate of candidates) {
    const fileProperties =
      candidate?.FileProperties ?? candidate?.fileProperties ?? {}
    const attachmentLink =
      candidate?.AttachmentLink ??
      candidate?.attachmentLink ??
      candidate?.AttachmentURL ??
      candidate?.attachmentUrl ??
      candidate?.path ??
      candidate?.url ??
      fileProperties?.publishedURL ??
      fileProperties?.publishedUrl ??
      fileProperties?.url

    if (attachmentLink) {
      return {
        attachmentLink,
        fileName:
          candidate?.Filename ??
          candidate?.filename ??
          candidate?.fileName ??
          candidate?.uploadedFileName ??
          fileProperties?.fileName ??
          candidate?.name ??
          fallbackFileName,
      }
    }
  }

  return null
}
